<mat-card class="overview-card">
  <mat-card-header>
    <div class="summary-type-icon">
      <img [src]="'assets/categories/'+overviewTypeConfig?.iconName" [alt]="overviewTypeConfig?.name + ' Icon'"/>
    </div>
    <mat-card-title-group>
      <mat-card-title class="summary-title">
        {{overviewTypeConfig?.name}}
      </mat-card-title>
      <mat-card-subtitle *ngIf="getSubtitle() != null">{{getSubtitle()}}</mat-card-subtitle>
    </mat-card-title-group>
    <div class="spacer"></div>
    <div class="summary-detail-button">
      <button class="mini" matTooltip="Monatswerte anzeigen" mat-mini-fab [routerLink]="overviewTypeConfig?.detailPath">
        <mat-icon>stacked_line_chart</mat-icon>
        <span>Monate</span>
      </button>
      <button class="full" mat-flat-button aria-label="Zeige Details" [routerLink]="overviewTypeConfig?.detailPath">
        <span>Monate</span>
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <hr class="solid">

    <div class="actual-value-box">
      <div *ngIf="werteSammlung2" class="actual-value-text">
        {{werteSammlung?.aktuell.jahreswert | number:'1.2-3':'de'}} {{werteSammlung?.einheit}}
      </div>
      <div *ngIf="werteSammlung2" class="actual-value-subtext">
        (entspricht {{werteSammlung2?.aktuell.jahreswert | number:'1.2-3':'de'}} {{werteSammlung2?.einheit}})
      </div>
      <div *ngIf="!werteSammlung2" class="actual-value-text">
        {{werteSammlung?.aktuell.jahreswert | number:'1.2-3':'de'}} {{werteSammlung?.einheit}}
      </div>
      <div class="actual-value-percentage">
        {{unterschiedVorjahr >= 0 ? '+' : ''}}{{unterschiedVorjahr | number:'1.2-2':'de'}} % zum Vorjahr
      </div>
    </div>

    <hr class="solid">

    <div class="compare-value-box">
      <div class="compare-value" [ngClass]="getColorByDifference()">
        <div class="compare-value-arrow" *ngIf="unterschiedVorjahr > 0">
          <mat-icon class="arrow more">arrow_upward</mat-icon>
        </div>
        <div class="compare-value-arrow" *ngIf="unterschiedVorjahr == 0">
          <mat-icon class="arrow same">arrow_upward</mat-icon>
        </div>
        <div class="compare-value-arrow" *ngIf="unterschiedVorjahr < 0">
          <mat-icon class="arrow less">arrow_upward</mat-icon>
        </div>
        <div>
          <div>
            Vorjahr
          </div>
          <div>
            {{werteSammlung?.vergleich.jahreswert | number:'1.2-3':'de'}} {{werteSammlung?.einheit}}
          </div>
        </div>
      </div>

      <div class="compare-building-average">
        <div class="compare-average-symbol">Ø</div>
        <div>
          <div>
            Liegenschaft
          </div>
          <div>
            {{werteSammlung?.durchschnittLiegenschaft.jahreswert | number:'1.2-3':'de'}} {{werteSammlung?.einheit}}
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
